import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getOrCreateReferralCode, getReferralStats, buildReferralUrl } from '../utils/referralUtils';

export function useReferralStats() {
  const { user } = useAuth();
  const [referralCode, setReferralCode] = useState(null);
  const [referralUrl, setReferralUrl] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadReferralData = useCallback(async () => {
    if (!user) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const { code } = await getOrCreateReferralCode(user.id);
      setReferralCode(code);
      setReferralUrl(buildReferralUrl(code));

      const referralStats = await getReferralStats(user.id);
      setStats(referralStats);
    } catch (err) {
      console.error('Error loading referral data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    loadReferralData();
  }, [loadReferralData]);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const referralStats = await getReferralStats(user.id);
      setStats(referralStats);
    } catch (err) {
      console.error('Error refreshing referral stats:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [user]);

  return {
    referralCode,
    referralUrl,
    stats,
    loading,
    error,
    refresh
  };
}
